import React from 'react'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone/'

const styles = {
  container: {
    display: 'flex',
    margin: '20px 0 0'
  },
  sidebar: {
    width: '280px',
    height: '100%',
    padding: '0 20px 0 32px'
  },
  content: {
    flex: '1',
    height: 'calc(100vh - 140px)',
    display: 'flex',
    background: '#e3e3e3',
    padding: '20px',
    marginTop: '-20px'
  },
  slideHolder: {
    flex: '1'
  },
  slide: {
    width: '100%',
    height: '0',
    padding: '0 0 56%',
    borderRadius: '0',
    background: 'var(--light-gray-)'
  },
  slidePreview: {
    height: '0',
    width: '100%',
    padding: '0 0 56%',
    borderRadius: '4px',
    marginBottom: '20px',
    background: 'var(--light-gray--)'
  },
  button: {
    height: '40px',
    borderRadius: '4px',
    marginBottom: '20px',
    background: 'var(--light-gray--)'
  }
}

const Skeleton = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.sidebar}>
      <Bone className={classes.button} />
      <Bone className={classes.slidePreview} />
      <Bone className={classes.slidePreview} />
    </div>
    <div className={classes.content}>
      <div className={classes.slideHolder}>
        <Bone className={classes.slide} />
      </div>
    </div>
  </div>
)

export default injectSheet(styles)(Skeleton)
